import useAPI from "./useAPI";

export default function useRamp() {
  const api = useAPI();

  const rampOperators = async () => {
    return await api.getRampOperators();
  }

  const adminRampMethods = async () => {
    return await api.getAdminRampMethods();
  }

  const adminDeleteRampMethod = async (id) => {
    return await api.deleteAdminRampMethod(id);
  }

  const adminCreateRampMethod = async (data) => {
    return await api.adminCreateRampMethod(data);
  }

  const adminUpdateRampMethod = async (data, id) => {
    return await api.adminUpdateRampMethod(id, data);
  }

  const rampSessions = async (page, limit) => {
    return await api.getAdminRampSessions(page, limit);
  }

  const paybisPairs = async () => {
    return await api.getPaybisPairs();
  }

  return {
    rampOperators,
    adminRampMethods,
    adminDeleteRampMethod,
    adminCreateRampMethod,
    adminUpdateRampMethod,
    rampSessions,
    paybisPairs
  };
}